/**
 * @generated SignedSource<<b0da45094f763771bf58f9959b3fa4f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectCardV2DataWrapper_userProfile$data = {
  readonly analyticsId: number;
  readonly id: string;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "ProjectCardV2DataWrapper_userProfile";
};
export type ProjectCardV2DataWrapper_userProfile$key = {
  readonly " $data"?: ProjectCardV2DataWrapper_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectCardV2DataWrapper_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectCardV2DataWrapper_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "78615594b970b213e2951a969686da2b";

export default node;
